import FsLightbox from 'fslightbox' // eslint-disable-line

class Video {

}

export default Video
